const Backbone = require('backbone');

const View = Backbone.View.extend({
	tagName: 'li',
	initialize: function() {
		var that = this;		

		that.listenTo(that.model,'remove', that.remove);

		that.render();
	},
	render: function() {
		var that = this;
		var data = that.model.toJSON();
		var url = data.titulo.toLowerCase().replace(/[^\d\w]/igm, ' ').replace(/\s+/igm,' ').replace(/\s+$/igm,'').replace(/^\s+/igm,'').replace(/\s/igm,'-')+'-'+data.id;

		that.$el.html(`<a href="kits-e-programas/interna/${url}">${data.titulo}</a>`);
	}
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/kits/categoria.js
// module id = 14
// module chunks = 0